import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

export interface AlertDialogProps {
    open: boolean;
    title: string;
    text: string;
    onClose: () => void;
}

const AlertDialog = ({open, title, text, onClose}: AlertDialogProps) => {
    const [t] = useTranslation();

    const close = () => {
        onClose();
    }

    if (!open)
        return null;

    return <div className="AlertDialog">
        <div className="dialogContainer">
            <div className="textContent">
                <div className="title">{title}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: text}} />
            </div>
            <div className="buttons">
                <div className="button no" onClick={close}>{t("close")}</div>
            </div>
        </div>
    </div>
}

export default AlertDialog;
